export const PROVIDER_TYPE = {
  SCHOOL: "SCHOOL",
  SPONSOR: "SPONSOR",
  EMPLOYER: "EMPLOYER",
} as const;

export type ProviderType = (typeof PROVIDER_TYPE)[keyof typeof PROVIDER_TYPE];

export const DUPLICATE_LEAD_BEHAVIOR_OPTION = {
  SEND_ONCE_CHARGE_ONCE: "SEND_ONCE_CHARGE_ONCE",
  SEND_ALL_CHARGE_ONCE: "SEND_ALL_CHARGE_ONCE",
  SEND_ALL_CHARGE_ALL: "SEND_ALL_CHARGE_ALL",
} as const;

export type DuplicateLeadBehaviorOption =
  (typeof DUPLICATE_LEAD_BEHAVIOR_OPTION)[keyof typeof DUPLICATE_LEAD_BEHAVIOR_OPTION];

export type MarketplaceConfig = {
  programFlowEmailStepHeader?: string | null;
  programFlowBasicInfoStepHeader?: string | null;
  /**
   * @deprecated Use programFlowHeadsUpPhoneDisclaimer or programFlowHeadsUpEmailDisclaimer instead
   */
  programFlowHeadsUpDisclaimer?: string | null;
  programFlowHeadsUpPhoneDisclaimer?: string | null;
  programFlowHeadsUpEmailDisclaimer?: string | null;
  openingHours?: string[];
};
